import { Component, OnInit } from '@angular/core';
import { label } from 'src/app/constants/labels';
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  labels = label;

  constructor() { }

  ngOnInit() {
  }

}
